// initial state
// shape: [{ id, quantity }]
const state = {
  userOptions: [],
}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getFairDeliverUpload ({commit, state}, params) {
    let promised = request.alert('getFairDeliverUpload', params)
    return promised
  },
  downFairSourceFile ({commit, state}, params) {
    let promised = request.alert('downFairSourceFile', params)
    return promised
  },
  downFairErrorFile ({commit, state}, params) {
    let promised = request.alert('downFairErrorFile', params)
    return promised
  },
  editRewardLogistics ({commit, state}, params) {
    let promised = request.alert('editRewardLogistics', params)
    return promised
  },
  uploadFairFile ({commit, state}, params) {
    let promised = request.alert('uploadFairFile', params)
    return promised
  },
}

// mutations
const mutations = {}

export const fairUpload = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/fair-upload/fairUpload.store.js